import { VStack } from "@chakra-ui/react";
import {
  EntityProfileFieldRow,
  EntityProfileTextList,
} from "../../../../../entityProfileModal/components/EntityProfilePreferenceControls";
import type {
  CaregiverStaffingPreferenceField,
  CaregiverStaffingPreferences,
  CaregiverStaffingPreferencesBody,
} from "../staffingPreferences.types";
import { formatCaregiverStaffingValue, getNullableBoolean } from "../staffingPreferences.utils";
import {
  CaregiverStaffingBooleanValue,
  CaregiverStaffingPreferenceEditor,
} from "./CaregiverStaffingPreferenceControls";

function getTextListItems(value: unknown) {
  if (!Array.isArray(value)) {
    return null;
  }

  return value.filter((item): item is string => typeof item === "string");
}

type Props = {
  draft: CaregiverStaffingPreferencesBody | null;
  fields: CaregiverStaffingPreferenceField[];
  preferences: CaregiverStaffingPreferences;
  onChangeDraft: (draft: CaregiverStaffingPreferencesBody) => void;
  onCommitDraft: (draft: CaregiverStaffingPreferencesBody) => void;
};

export function CaregiverStaffingPreferenceColumn(props: Props) {
  return (
    <VStack alignItems="stretch" spacing={0}>
      {props.fields.map((field) => {
        if (
          field.key === "studyingTimes" &&
          (props.draft?.studying ?? props.preferences.studying) !== true
        ) {
          return null;
        }

        const draft = props.draft;
        const preferenceValue = props.preferences[field.key];
        const textListItems = getTextListItems(preferenceValue);
        let value: React.ReactNode =
          field.getValue?.(props.preferences) ??
          (textListItems !== null ? (
            <EntityProfileTextList items={textListItems} />
          ) : (
            formatCaregiverStaffingValue(preferenceValue)
          ));

        if (field.type === "boolean") {
          value = (
            <CaregiverStaffingBooleanValue
              value={getNullableBoolean(props.preferences[field.key])}
            />
          );
        }
        const editor =
          draft !== null && field.type === "boolean" ? (
            <CaregiverStaffingBooleanValue
              value={getNullableBoolean(draft[field.key])}
              onChange={(nextValue) => {
                const nextDraft = { ...draft, [field.key]: nextValue };

                props.onChangeDraft(nextDraft);
                props.onCommitDraft(nextDraft);
              }}
            />
          ) : draft !== null ? (
            <CaregiverStaffingPreferenceEditor
              draft={draft}
              fieldKey={field.key}
              onChangeDraft={props.onChangeDraft}
              onCommitDraft={props.onCommitDraft}
            />
          ) : null;

        return (
          <EntityProfileFieldRow key={field.key} label={field.label} value={editor ?? value} />
        );
      })}
    </VStack>
  );
}
